import {html} from 'lit';
import Base from '../base.js';
import styles from './input-checkbox.css' assert {type: 'css'};

/**
 * @element inv-input-checkbox
 *
 * @class InputCheckbox
 * @extends Base
 * @classdesc InputCheckbox component
 *
 * @property {String} name - name of input
 *
 * @cssproperty --inv-font-family
 * @description the font family for the application
 * @type {string}
 * @default "Inter"
 *
 * @cssproperty --inv-input-checkbox-font-size
 * @description the font size for input checkbox
 * @type {string}
 * @default "1em"
 *
 * @cssproperty --inv-input-checkbox-border-color
 * @description the border color for input checkbox
 * @type {string}
 * @default "#548de3"
 *
 * @cssproperty --inv-input-checkbox-box-shadow-color
 * @description the box shadow color for input checkbox
 * @type {string}
 * @default "#548de3"
 */

export default class InputCheckbox extends Base {
    constructor() {
        super();
        this.name = 'checkbox';
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    static get properties() {
        return {
            ...super.properties,
            value: {
                type: String,
            },
        };
    }

    render() {
        return html`
            <label class="form-control" for="${this.name}">
                <input
                    @change=${this.buildHandler('change')}
                    value="${this.value}"
                    type="checkbox"
                    name="${this.name}"
                    id="${this.name}"
                    ?disabled=${this.disabled}
                />
                <slot></slot>
            </label>
        `;
    }
}
InputCheckbox.register();
